export default __webpack_public_path__ + "static/media/create-campaigns-2.59ae7952.png";